export const SETTINGS_KEYS = {
  showLabels: 'grafana.explore.logs.showLabels',
  showTime: 'grafana.explore.logs.showTime',
  wrapLogMessage: 'grafana.explore.logs.wrapLogMessage',
  prettifyLogMessage: 'grafana.explore.logs.prettifyLogMessage',
  logsSortOrder: 'grafana.explore.logs.sortOrder',
  logContextWrapLogMessage: 'grafana.explore.logs.logContext.wrapLogMessage',
};

export const visualisationTypeKey = 'grafana.explore.logs.visualisationType';
